import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router';
import { Grid, Box, Typography, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { Layout } from '@roc/feature-app-core';
import { JourneyBuilderDashboard } from '../journeyBuilderDashboard/journeyBuilderDashboard';
import { UserMetricsByDashboard } from '../leadsDashboard/userMetricsByDashboard';
import { OutreachOverallDashboard } from './outreachOverallDashboard';
import { SalesManagementDashboard } from './salesManagementDashboard';

type ViewKey = 'outreach' | 'sales' | 'journey' | 'specificOutreach';

export const VIEW_QUERY_PARAM = 'view';

const VIEW_LABEL: Record<ViewKey, string> = {
  outreach: 'Outreach Overall',
  sales: 'Overall Insights',
  journey: 'Journey Builder',
  specificOutreach: 'Specific Outreach',
};

const VIEW_COMPONENT: Record<ViewKey, React.ComponentType> = {
  outreach: OutreachOverallDashboard,
  sales: SalesManagementDashboard,
  journey: JourneyBuilderDashboard,
  specificOutreach: UserMetricsByDashboard
};

export default function CrmSpecsDashboardSwitcher() {
  const { search, pathname } = useLocation();
  const { replace } = useHistory();
  // the selected dashboard lives in the url (?view=)
  const viewParam = new URLSearchParams(search).get(VIEW_QUERY_PARAM) as ViewKey;
  const view: ViewKey = viewParam && VIEW_COMPONENT[viewParam] ? viewParam : 'sales';
  const Current = useMemo(() => VIEW_COMPONENT[view], [view]);

  const handleViewChange = (nextView: ViewKey) => {
    const params = new URLSearchParams();
    params.set(VIEW_QUERY_PARAM, nextView);
    replace({ pathname, search: params.toString() });
  };

  return (
    <Layout>
      <Box px={2} py={1} borderBottom="1px solid #ddd">
        <Grid container direction="column" alignItems="flex-start">
          <Grid item>
            <Typography variant="h3">{VIEW_LABEL[view]}</Typography>
          </Grid>
          <Grid item>
            <FormControl variant="outlined" size="medium" style={{ minWidth: 20, marginTop: 8 }}>
              <InputLabel id="dashboard-view-label">Select Dashboard</InputLabel>
              <Select
                labelId="dashboard-view-label"
                label="Select Dashboard"
                value={view}
                onChange={(e) => handleViewChange(e.target.value as ViewKey)}
              >
                <MenuItem value="sales">{VIEW_LABEL.sales}</MenuItem>
                <MenuItem value="outreach">{VIEW_LABEL.outreach}</MenuItem>
                <MenuItem value="journey">{VIEW_LABEL.journey}</MenuItem>
                <MenuItem value="specificOutreach">{VIEW_LABEL.specificOutreach}</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box>

      <Current />
    </Layout>
  );
}